module.exports = _dll_vendors8_67844dd1cc899c2ca193;